import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '../../Session';
import { UserType } from '../../api';
import BasicLayout from '../../layouts/BasicLayout';
import PurchaseTransactionsList from '../../pages/PurchaseTransactions/PurchaseTransactionsList';
import { DownloadPurchaseTransactionsFileProvider } from '../../pages/PurchaseTransactions/components';

const PurchaseTransactionsRoute = () => {
    const currentUser = useCurrentUser();

    if (
        ![UserType.Admin, UserType.Root, UserType.SaleConsultant, UserType.ValuationTeam, UserType.Approver].includes(
            currentUser.type
        )
    ) {
        return <Redirect to="/403" />;
    }

    return (
        <BasicLayout>
            <DownloadPurchaseTransactionsFileProvider>
                {downloadFile => <PurchaseTransactionsList downloadPurchaseTransactionsFile={downloadFile} />}
            </DownloadPurchaseTransactionsFileProvider>
        </BasicLayout>
    );
};

export default PurchaseTransactionsRoute;
